<app-input-wrapper [label]="label">
	<app-matter-user-select-or-search
		[disabled]="disabled"
		[filterIds]="filterIds"
		[filterByParent]="filterByParent && parentId"
		[selectedId]="value"
		[prefilledNewClient]="prefilledNewClient"
		(remove)="remove()"
		(selectedCurrent)="select($event)"
		(selectedAddClient)="select($event)"
		(selectedCreateClient)="create($event)"
		[placeholder]="placeholder"
		[title]="title"
		[noResultsMessage]="noResultsMessage"
	></app-matter-user-select-or-search>
</app-input-wrapper>
